const videoOverVideoDefinitions = [
	{
		page: '12',
		scrollSpeed: 0.45,
    backgroundVideo: {
        video: './video/video-over-video/12-LaBolaNegra_StreetWalk_trimCrop_3Kkbps.mp4',
        poster: './video/video-over-video/12-LaBolaNegra_StreetWalk_trimCrop_3Kkbps-poster.jpg'
    },
		cards: [
      {
				video: './video/video-over-video/12-Clip1_3Kkbps.mp4',
        poster: './video/video-over-video/12-Clip1_3Kkbps-poster.jpg',
			},
      { 
        video: './video/video-over-video/12-Clip2_3Kkbps.mp4',
        poster: './video/video-over-video/12-Clip2_3Kkbps-poster.jpg'
      },
      { 
        video: './video/video-over-video/12-Clip3_3Kkbps.mp4',
        poster: './video/video-over-video/12-Clip3_3Kkbps-poster.jpg'
      },
      { 
        video: './video/video-over-video/12-Clip4_3Kkbps.mp4',
        poster: './video/video-over-video/12-Clip4_3Kkbps-poster.jpg'
      },
      { 
        video: './video/video-over-video/12-Clip5_3Kkbps.mp4',
        poster: './video/video-over-video/12-Clip5_3Kkbps-poster.jpg'
      },
		],
	},
];


export default videoOverVideoDefinitions;